import { TripModePicker as TripModePickerView } from 'app/components/ui/TripModePicker';
import { connect } from 'react-redux';
import { optionsSelector, returnDateVisibleSelector } from 'app/store/selectors';
import { emitFieldChangedEvent } from 'app/events';
import { FIELD_TRIP_MODE } from 'app/storage/fieldNames';
import { StoreState } from 'app/models/types';
import { requestSearch } from 'app/store/thunk/general/requestSearchThunk';
import { AppDispatch } from 'app/hooks/appHooks';
import { toggleReturnDate } from 'app/store/reducers/date';

const mapStateToProps = (state: StoreState) => ({
  isRoundTrip: returnDateVisibleSelector(state),
  options: optionsSelector(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  toggleReturnDateVisible: (isVisible: boolean) => dispatch(toggleReturnDate({ isVisible })),
  requestSearch: () => dispatch(requestSearch({})),
});

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: ReturnType<typeof mapDispatchToProps>,
) => {
  const callRequestSearch = () => dispatchProps.requestSearch();

  return {
    ...stateProps,
    onClickOneWayToggle: () => {
      emitFieldChangedEvent(FIELD_TRIP_MODE, 'oneway');
      dispatchProps.toggleReturnDateVisible(false);

      if (stateProps.options.autoUpdate) {
        callRequestSearch();
      }
    },
    onClickRoundTripToggle: () => {
      dispatchProps.toggleReturnDateVisible(true);
      emitFieldChangedEvent(FIELD_TRIP_MODE, 'roundtrip');

      if (stateProps.options.autoUpdate) {
        callRequestSearch();
      }
    },
  };
};

export const TripModePicker = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(TripModePickerView);
